<template>
  <div class="complete-lesson" @click="completeLesson">
    <template v-if="isLastLesson && isLastModule">
      <p class="text">Finish course</p>
      <p class="lesson-name">Congratulations! Click to finish the course</p>
    </template>
    <template v-else-if="isLastLesson">
      <p class="text">Finish module</p>
      <p class="lesson-name">Go back to module list</p>
    </template>
    <template v-else>
      <p class="text">Next lesson</p>
      <p class="lesson-name">{{ name }}</p>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: 'lesson'
    },
    isLastModule: {
      type: Boolean,
      required: true
    },
    isLastLesson: {
      type: Boolean,
      required: true
    },
    name: {
      type: String,
      required: true
    }
  },

  methods: {
    completeLesson () {
      this.$emit('finishLesson')
    }
  }
}
</script>

<style lang="scss">

@import '~styles/base/variables';
@import '~styles/base/mixins';

.complete-lesson {
  padding: 1.5rem;
  border: 1px solid $color-gray-medium;
  cursor: pointer;
  position: relative;

  .text {
    @include text-size-xs();
    font-weight: $font-weight-bold;
    text-transform: uppercase;
  }

  .lesson-name {
    @include text-size-l();
    font-weight: $font-weight-semibold;
  }

  .lesson-name {
    color: $color-text-dark;
    font-weight: $font-weight-semibold;
  }

  &::after {
    position: absolute;
    content: '▶';
    top: 50%;
    right: 1.5rem;
    transform: translateY(-50%);
  }

  &:hover {
    border-color: $color-text-dark;

    &::after {
      color: $color-text-dark;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/FinishLessonButton.vue